import { MANAGE_ROUTE_PREFIX } from '../data/manage-paths';

/**
 * Builds an absolute URL path for manage module routes. `path` values may
 * contain `/` (e.g. `modules/customers`). Do not pass the whole string as a
 * single `Router.navigate` command — each array entry is one segment.
 */
export function manageAbsolutePath(path: string, ...extraSegments: string[]): string {
  const prefix = MANAGE_ROUTE_PREFIX.replace(/^\/+|\/+$/g, '');
  const base = path.replace(/^\/+|\/+$/g, '');
  const extras = extraSegments
    .flatMap((s) => s.split('/'))
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
  return '/' + [prefix, base, ...extras].filter((p) => p.length > 0).join('/');
}
